import _ from 'lodash';
import listService from 'ListService';
import util from 'util/Util';
import restService from 'RestService';

const _standardFonts = [
    {name: 'Sans Serif', value: 'sans-serif', abbr: 'sans-serif'},
    {name: 'Serif', value: 'serif', abbr: 'serif'},
    {name: 'Typewriter', value: 'monospace', abbr: 'monospace'},
    {name: 'Verdana', value: 'verdana', abbr: 'verdana'}
];

// These are found on Windows and Mac OS machines the 93rd percentile range:
const _customSystemFonts = [
    {name: 'Arial', value: 'Arial', abbr: 'arial' },
    {name: 'Arial Black', value: 'Arial Black', abbr: 'arial-black'},
    {name: 'Bookman', value: 'Bookman', abbr: 'bookman'},
    {name: 'Charcoal', value: 'Charcoal', abbr: 'charcoal'},
    {name: 'Comic Sans MS', value: 'Comic Sans MS', abbr: 'comic-sans-ms'},
    {name: 'Courier', value: 'Courier', abbr: 'courier'},
    {name: 'Courier New', value: 'Courier New', abbr: 'courier-new'},
    {name: 'Gadget', value: 'Gadget', abbr: 'gadget'},
    {name: 'Garamond', value: 'Garamond', abbr: 'garamond'},
    {name: 'Geneva', value: 'Geneva', abbr: 'geneva'},
    {name: 'Georgia', value: 'Georgia', abbr: 'georgia'},
    {name: 'Helvetica', value: 'Helvetica', abbr: 'helvetica'},
    {name: 'Impact', value: 'Impact', abbr: 'impact'},
    {name: 'Lucida Console', value: 'Lucida Console', abbr: 'lucida-console'},
    {name: 'Lucida Grande', value: 'Lucida Grande', abbr: 'lucida-grande'},
    {name: 'Lucida Sans Unicode', value: 'Lucida Sans Unicode', abbr: 'lucida-sans-unicode'},
    {name: 'Monaco', value: 'Monaco', abbr: 'monaco'},
    {name: 'Palatino', value: 'Palatino', abbr: 'palatino'},
    {name: 'Tahoma', value: 'Tahoma', abbr: 'tahoma'},
    {name: 'Times', value: 'Times', abbr: 'times'},
    {name: 'Times New Roman', value: 'Times New Roman', abbr: 'times-new-roman'},
    {name: 'Trebuchet MS', value: 'Trebuchet MS', abbr: 'trebuchet-ms'}
];

 //PF-9500 This will be the default font for all controls in all new accounts
const _defaultFont =[
    {name: 'Poppins', value: 'Poppins', abbr: 'poppins' }
];

const _fontSizes = [8,9,10,11,12,14,16,18,20,24,28,32,48];

class FontService {

    constructor() {
        this._fonts = [];        
        this._webFonts = [];
        this._userCustomFonts = [];
    }

    getFonts() {
        if (util.isTrue(listService.accountSettings.UseSystemFont)) {
            this._userCustomFonts = listService.accountSettings.CustomFonts ? util.enforceArrayType(JSON.parse(listService.accountSettings.CustomFonts)) : [];
            this._fonts =  _.union(_standardFonts, _customSystemFonts, this._userCustomFonts, this.getWebFonts());
        } else {
            this._fonts = _.union(_standardFonts, this.getWebFonts());
        }
        return this._fonts;
    }

    getStandardFonts(){
        return _standardFonts;
    }

    getDefaultFont(){
        return _defaultFont;
    }

    getCustomFonts(){
        this._userCustomFonts = listService.accountSettings.CustomFonts ? util.enforceArrayType(JSON.parse(listService.accountSettings.CustomFonts)) : [];
        const allCustomFonts = _.union(_customSystemFonts, this._userCustomFonts);
        allCustomFonts.sort((a, b) => (a.name > b.name) ? 1 : -1)
        return  allCustomFonts;
    }

    getWebFonts(){   
        this.webFonts = listService.accountSettings.WebFonts && listService.accountSettings.WebFonts !== "[]" ? util.enforceArrayType(JSON.parse(listService.accountSettings.WebFonts)) : [];
        this.webFonts.sort((a, b) => (a.name > b.name) ? 1 : -1);
        return this.webFonts;
    }

    loadWebFontResource(fontObj) {

        const url = restService.hostUrl + '/resources/fonts/' + fontObj.file;
        const font = new FontFace(fontObj.name, 'url(' + url + ')');
        
        if(font.status === "unloaded" || font.status === "error"){
            font.load().then(function (loadedFont) {
                document.fonts.add(loadedFont);
            }).catch(function (error) {
                console.error("Error loading web font " + fontObj.name + " - " + error);
            });
        }
    }

    isCustomFont(currentFont){
        let fonts = this.getFonts();
        let fontFamily = currentFont;
        let isCustomFont = false;

        if(fontFamily){
            let font = fonts.filter((_fontFamily, idx) => {
                return _fontFamily.name.toLowerCase() === fontFamily.toLowerCase() || (_fontFamily.abbr && _fontFamily.abbr.toLowerCase() === fontFamily.toLowerCase());
            });
    
            isCustomFont = font.length === 0;
        }

        return isCustomFont;       
    }

    loadFontsDropDown(addCustomOption){

        let options = "";

        //Load standard fonts
        options += "<optgroup label='Standard Fonts'>"
        _.each(this.getStandardFonts(), (f) => {
            options += `<option value='${f.value}'> ${f.name} </option>`;
        });
        options += "</optgroup>"

        //Load web fonts
        options += "<optgroup label='Web Fonts'>"
        _.each(this.getWebFonts(), (f) => {
            options += `<option value='${f.value}'> ${f.name} </option>`;
        });
        options += "</optgroup>"

        if (util.isTrue(listService.accountSettings.UseSystemFont)) {
            //Load custom fonts
            options += "<optgroup label='Custom Fonts'>"
            _.each(this.getCustomFonts(), (f) => {
                options += `<option value='${f.value}'> ${f.name} </option>`;
            });

            if(addCustomOption){
                options += `<option value="__custom__">Custom</option>`
            }
            
            options += "</optgroup>"
        }

       return options;
    }

    initCustomFont(model, currentFont, buttonFont){
        let fontFamily = currentFont;
        const targetFont = buttonFont ? 'customButtonFontFamily' : 'customFontFamily';
        const targetDisabled =  buttonFont ? 'customButtonFontFamilyDisabled' : 'customFontFamilyDisabled';

       
        if (!model.get(targetFont)){
            model.set(targetFont, '', {silent: true});    
            model.set(targetDisabled, 'disabled', {silent: true});
        }

        if (this.isCustomFont(fontFamily)) {//If is a custom font
            fontFamily = fontFamily === "__custom__" ? "" : fontFamily;
            model.set(targetFont, fontFamily, { silent: true });
            model.set(targetDisabled, '', { silent: true });
        }
    }

    updateCustomFont(model, propVal, buttonFont){
        let _propVal = propVal;
        const targetFont = buttonFont ? 'customButtonFontFamily' : 'customFontFamily';
        const targetDisabled =  buttonFont ? 'customButtonFontFamilyDisabled' : 'customFontFamilyDisabled';

        
        if (this.isCustomFont(_propVal)) {//If is a custom font
            _propVal = _propVal === "__custom__" ? "" : _propVal;
            model.set(targetFont, _propVal, { silent: true });
            model.set(targetDisabled, '', {silent: true});
        }
        else{

            model.set(targetFont, '', {silent: true});    
            model.set(targetDisabled, 'disabled', {silent: true});
        }

        return _propVal;
    }

    getFontSizes() {
        return _fontSizes;
    }

    set webFonts(value) {
        if(typeof value === "string")
        {
            if(value.length > 0)
            {
                this._webFonts = util.enforceArrayType(JSON.parse(value));
            }
            else
            {
                this._webFonts = '';
            }
            
            listService.accountSettings.WebFonts = value;
        }
        else if(Array.isArray(value))
        {
            this._webFonts = value;
            listService.accountSettings.WebFonts = JSON.stringify(value);
        }
    }

    get webFonts() {
        return this._webFonts;
    }

    set userCustomFonts(value) {
        if(typeof value === "string")
        {
            if(value.length > 0)
            {
                this._userCustomFonts = util.enforceArrayType(JSON.parse(value));
            }
            else
            {
                this._userCustomFonts = '';
            }
            listService.accountSettings.CustomFonts = value;
        }
        else if(Array.isArray(value))
        {
            this._userCustomFonts = value;
            listService.accountSettings.CustomFonts = JSON.stringify(value);
        }
    }

    get userCustomFonts() {
        return this._userCustomFonts;
    }
}


const fontService = new FontService();
export default fontService;